<template>
    <div class="fixed inset-0 z-50 overflow-auto bg-smoke-light flex">
        <div class="flex justify-center w-full h-full">
            <div class="self-start bg-white relative w-2/5 h-auto z-40 mt-12">
                <header class="flex items-center text-white p-2 relative bg-red-100">
                    <h6 v-if="title" class="h1">
                        <Icon v-if="titleIcon" :name="titleIcon" />
                        <span v-html="title" />
                    </h6>
                    <button
                        @click="close"
                        type="button"
                        class="button button-clean modal-close"
                    >
                        <Icon name="x-circle" />
                    </button>
                </header>

                <div class="p-4">
                    <slot />
                </div>
            </div>
        </div>
        <div @click="close" class="modal-bg" />
    </div>
</template>

<script>
    import $ from 'jquery';

    const $body = $('body');

    export default {
        name: 'Modal',
        props: {
            title: {
                required: false,
                type: String,
                default: '',
            },
            titleIcon: {
                required: false,
                type: String,
                default: '',
            },
        },
        mounted() {
            $body.addClass('modal-open');
        },
        methods: {
            close() {
                $body.removeClass('modal-open');
                this.$emit('close');
            },
        },
    };
</script>
